import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_STATE = {
  documents: [],
  isLoading: false,
  isLoadingMore: false,
  isLastPage: false,
  pageNumber: 0,
};

const workspaceV2Slice = createSlice({
  name: "workspaceV2",
  initialState: INITIAL_STATE,
  reducers: {
    setWorkspaceDocuments(state, { payload }) {
      state.documents = payload || [];
    },
    appendWorkspaceDocuments(state, { payload }) {
      state.documents = (state.documents || []).concat(payload || []);
    },
    resetWorkspaceDocuments(state) {
      state.documents = [];
      state.pageNumber = 0;
      state.isLastPage = false;
    },
    setIsLoading(state, { payload }) {
      state.isLoading = Boolean(payload);
    },
    setIsLoadingMore(state, { payload }) {
      state.isLoadingMore = Boolean(payload);
    },
    setIsLastPage(state, { payload }) {
      state.isLastPage = Boolean(payload);
    },
    setPageNumber(state, { payload }) {
      state.pageNumber = payload ?? 0;
    },
  },
});

export const {
  setWorkspaceDocuments,
  appendWorkspaceDocuments,
  resetWorkspaceDocuments,
  setIsLoading,
  setIsLoadingMore,
  setIsLastPage,
  setPageNumber,
} = workspaceV2Slice.actions;

export default workspaceV2Slice.reducer;
